import { Icon } from 'antd';
import * as React from 'react';
import Asterisk from 'src/components/common/Asterisk';

const SEFieldLabel: React.FC<{
  children?: React.ReactNode;
  size?: string;
  bold?: boolean;
  style?: React.CSSProperties;
  label?: string;
  isRequired?: boolean;
  onEdit?: () => void;
}> = ({
  children = undefined,
  size = 'small',
  bold = false,
  style = {},
  label = '',
  isRequired = false,
  onEdit,
}) => {
  const fontSize = {
    small: '12px',
    normal: '14px',
    large: '16px',
    larger: '18px',
  };
  const fontWeight = bold ? 'bold' : 'normal';
  return (
    <span
      style={{
        fontWeight,
        fontSize: fontSize[size],
        color: '#333333',
        marginTop: 7,
        lineHeight: 2,
        ...style,
      }}
    >
      {children || label || ''}
      {isRequired ? <Asterisk /> : ''}
      {onEdit ? (
        <Icon
          style={{
            color: '#0780FE',
            marginLeft: 10,
          }}
          type="edit"
          onClick={onEdit}
        />
      ) : null}
    </span>
  );
};

export default SEFieldLabel;